// extracted by mini-css-extract-plugin
export var buttonInner = "transition-weekly-module--button-inner--VYZdI";
export var container = "transition-weekly-module--container--ZEJvz";
export var content = "transition-weekly-module--content--l6442";
export var errorText = "transition-weekly-module--error-text--P7dr6";
export var header = "transition-weekly-module--header--GhK+W";
export var loader = "transition-weekly-module--loader--4yQ1t";
export var loading = "transition-weekly-module--loading--huKB9";
export var title = "transition-weekly-module--title--7lb76";